<script>
import Feed from '@components/feed'
import InfiniteLoading from 'vue-infinite-loading';
export default {
  components: {
    Feed,
    InfiniteLoading
  },
  props: {
    feeds: {
      type: Array,
      default: null,
    }
  },
  data() {
    return {
      isLoaded: false,
      mainfeeds: null,
      profile: null,
      page: 2,
      loading: false,
      bottom: false,
    }
  },
  watch: {
    feeds(){
      this.mainfeeds = this.feeds
    }
  },
  created() {
    this.$store
      .dispatch('profile/myProfile')
      .then((response) => {
        this.profile = response.data
      })
      .catch((error) => {
        console.log (error.response)
      })
  },
  beforeMount() {
    this.mainfeeds = this.feeds
    this.mainfeeds.type = 'mainfeeds'
    if(this.feeds){
      this.isLoaded = true
    }
  },
  methods: {
    infiniteHandler($state) {
      this.$store
      .dispatch('feed/mainFeeds',{ page: this.page})
      .then((response) => {
        if(response.meta.pagination.total_pages > this.page){
          this.page += 1;
          this.feeds.push(...response.data)
          $state.loaded();
        }else{
          $state.complete();
        }
      })
      .catch((error) => {
        $state.complete();
        console.log(error)
      });
    },
  }
}
</script>
<template>
  <div v-if="isLoaded">
    <div v-for="(feed, index) in feeds" :key="index" class="feed">
      <Feed :feed="feed" :type="mainfeeds.type"/>
    </div>
    <InfiniteLoading spinner="waveDots" @infinite="infiniteHandler"></InfiniteLoading>
  </div>
</template>

<style lang="scss" scoped>
  .feed {
    margin-top: 25px;
    transition: all 0.5s;
  }
</style>
